import { Routes } from '@angular/router';
import { NotFoundComponent } from './components/_error-pages/not-found/not-found.component';
import { AppLayoutComponent } from './components/_layout/app-layout/app-layout.component';
import { HomeComponent } from './components/home/home.component';
import { UserNotAuthenticatedComponent } from './components/_error-pages/user-not-authenticated/user-not-authenticated.component';
import { AdminComponent } from './components/admin/admin.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', pathMatch: 'full', component: HomeComponent },
            { path: 'admin', pathMatch: 'full', component: AdminComponent },
            { path: 'not-found', component: NotFoundComponent },
            { path: 'user-not-authenticated', component: UserNotAuthenticatedComponent },
        ],
    },
    { path: '**', redirectTo: 'not-found' },
];
